var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "subheader mb-2 pb-2" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex_in cursor-pointer",
            on: {
              click: function ($event) {
                return _vm.copy(_vm.editor_in)
              },
            },
          },
          [_c("i", { staticClass: "fal fa-copy fs-xxl" })]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "debug_info jsoneditor_getorder" }, [
        _c("div", {
          ref: "jsonInContainer",
          staticClass: "ace-monokai",
          staticStyle: { height: "65vh" },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load } }, [
          _c("div", { staticClass: "subheader mb-2 pb-2" }, [
            _c("h1", { staticClass: "subheader-title" }, [
              _c("i", { staticClass: "subheader-icon fal fa-window" }),
              _vm._v(" JSON_OUT\n                "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex_in cursor-pointer",
                on: {
                  click: function ($event) {
                    return _vm.copy(_vm.editor_out)
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-copy fs-xxl" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "debug_info jsoneditor_getorder" }, [
            _c("div", {
              ref: "jsonOutContainer",
              staticClass: "ace-monokai",
              staticStyle: { height: "65vh" },
            }),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "subheader-title" }, [
      _c("i", { staticClass: "subheader-icon fal fa-window" }),
      _vm._v(" JSON_IN\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }